import React, { useEffect, useRef, useState } from 'react';
import Select from "react-select";
import { aboutnew, arrow, arrowleft, brandImg1, brandImg2, brandImg3, brandImg4, brandImg5, brandImg6, businesssuccess, calender, commas, dblArrow, hand, heroImg, heroimg3, heroimg4, homecard1, img1, img2, img3, img4, img5, img6, img7, img8, img9, line, minus, newtrade, plus, rightarrow, trades2, trades3, tradesnew, zigzagarrow } from '../../assets/imagesPath';
import Button from '../../components/button/Button';
import { Link, useNavigate } from 'react-router-dom';
import { useContactFormMutation } from "../../services/Api";
import { toast } from "react-toastify";
import Loader from "../../components/loader";
import { useForm } from "react-hook-form";
import PATHS from '../../routes/Paths';
import CustomDropdown from '../../components/CustomDropdown/CustomDropdown';
import { states } from '../../data/States';
import { useSelector } from 'react-redux';

const Home = () => {

  const [openSection, setOpenSection] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAgreed, setIsAgreed] = useState(false);
  const [state, setState] = useState("");
  const [businessName, setBusinessName] = useState("");
  const navigate = useNavigate();
  const topDivRef = useRef(null);
  // const sliderRef = useRef(null);
  const getStartedNowRef = useRef(null);
  const [contactForm] = useContactFormMutation();
  const [loading, setLoading] = useState(false);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);


  const handleGetStartedClick = () => {
    getStartedNowRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const {
    register,
    handleSubmit,
    reset,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setLoading(true);
    contactForm({ data })
      .unwrap()
      .then(() => {
        toast.success("Form submitted successfully");
        reset();
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error?.data?.message || "Submission failed");
        setLoading(false);
      });
  };
  const handleButtonClick = () => {
    if (!isLoggedIn) {
      toast.error("Please log in to continue.");
      navigate(PATHS.login);

      return;
    }
    validationHandler();
  };


  const validationHandler = () => {
    // let noError = false;

    stateValidationHandler();
    businessNameValidationHandler();

    if (state) {
      localStorage.setItem('intial_state', state)
      navigate(PATHS.basicInfo);
    } else {
      return false;
    }

    // return noError;
  };

  const businessNameValidationHandler = () => {
    if (!businessName) {
      setError("businessName", { type: "custom", message: "Option is required" });
    } else {
      clearErrors("businessName");
    }
  }
  const stateValidationHandler = () => {
    if (!state) {
      setError("state", { type: "custom", message: "Option is required" });
    } else {
      clearErrors("state");
    }
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials?.length - 1 ? 0 : prevIndex + 1
    );
  };
  const validateName = (value) => (value.trim() ? true : "Name is required.");
  const validateEmail = (value) =>
    !value.trim()
      ? "Email is required."
      : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
        ? true
        : "Invalid email address.";
  const validateMessage = (value) => (value.trim() ? true : "Message is required.");

  // const handlePrev = () => {
  //   setCurrentIndex((prevIndex) =>
  //     prevIndex === 0 ? testimonials?.length - 1 : prevIndex - 1
  //   );
  // };

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 3000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  const toggleSection = (sectionId) => {
    setOpenSection(openSection === sectionId ? null : sectionId);
  };

  const collapseData = [
    {
      "id": 1,
      "title": "What services does SBAAA LLC offer?",
      "content": "SBAAA LLC provides core services like bookkeeping, financial planning, business advisory, tax planning, and LLC/S-Corp formation. For services outside our expertise, we can guide you on the next steps or refer you to one of our trusted network affiliates. Refer to our Services page for more information."
    },
    {
      "id": 2,
      "title": "How can SBAAA LLC help my small business?",
      "content": "We streamline your finances, save you time, and help you make informed decisions. If a need arises outside our expertise, we will offer guidance or recommend a trusted affiliate. Learn more on our Services page."
    },
    {
      "id": 3,
      "title": "Do you work with businesses in specific industries?",
      "content": "Yes, we specialize in serving small businesses and tradespeople, such as electricians, plumbers, and remodelers. For highly specialized needs, we'll connect you with affiliates listed on our Network Affiliates page."
    },
  ];

  const collapseData2 = [
    {
      "id": 4,
      "title": "What is included in your bookkeeping services?",
      "content": "Our bookkeeping services include transaction tracking, financial reporting, and cash flow management. For additional or specialized services, we may recommend trusted affiliates or guide you on how to proceed. Visit our Services page for a full breakdown."
    },
    {
      "id": 5,
      "title": "How do I start using your bookkeeping services?",
      "content": "To start with our bookkeeping services, visit our Services page and select the option that best fits your business needs."
    },
    {
      "id": 6,
      "title": "Can SBAAA LLC help me clean up past financial records?",
      "content": "Yes, we specialize in cleaning up past financial records. Our team will review your existing data, identify any discrepancies, and ensure your records are accurate and up to date. This service is tailored to help you start fresh with clear financial insights, so you can confidently manage your business moving forward."
    }
  ];

  const testimonials = [
    {
      id: 1,
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
      name: "John Smith",
      icon: commas,
    },
    {
      id: 2,
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
      name: "John Smith",
      icon: commas,
    },
    {
      id: 3,
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.",
      name: "John Smith",
      icon: commas,
    },
  ];


  const options = [
    { value: 'businessAdvisory', label: 'Business Advisory' },
    { value: 'bookkeeping', label: 'Bookkeeping' },
    { value: 'establishedBusiness', label: 'Established Business' },
  ];

  const scrollToTop = () => {
    topDivRef.current.scrollIntoView({ behavior: "smooth" });
  };

  // const duplicatedSlides = [...testimonials, ...testimonials, ...testimonials];

  const customStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "white",
      border: "1px solid #ddd",
      borderRadius: "10px",
      padding: "5px",
      fontSize: "1.2rem",
      cursor: "pointer",

    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#173363",
      borderRadius: "4px",
    }),
    menuList: (provided) => ({ ...provided, paddingTop: 0, paddingBottom: 0, }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "white" : "#173363",
      color: state.isFocused ? "#173363" : "white",
      cursor: "pointer",
      fontSize: "1.2rem",
      // padding: "8px",
      borderRadius: "4px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    singleValue: (base) => ({
      ...base,
      color: "black",
      fontSize: "1.6rem",
    }),
  };

  const handleChange = (selectedOption) => {
    setState(selectedOption.value);
  };
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-[4rem] bg-[#F2F2F282]">
        <div className="pl-[25%] my-auto smallScreens:pl-8 smallScreens:pr-8">
          <h1 className="text-[4rem] smallScreens:text-[3rem] font-bold leading-tight animate-fadeInUp">Small Business Accounting & Advisory Administration</h1>
          <p className="mt-3 text-[#64666C] text-[1.8rem] font-normal italic">
            Your Trusted Catalyst for Success
          </p>


          <div className="mt-20">
            <Button label="Get Started" className="blackBtn flex flex-row-reverse items-center transform -translate-y-1/2 hover:bg-[#173363]" icon={arrow} onClick={handleGetStartedClick} />

          </div>
          <p className="mt-1 text-[#64666C] text-[1.8rem] font-normal">
            Tell us about your business, and we’ll tailor our services to meet your unique needs. It’s quick, simple, and the first step toward building a successful partnership.
          </p>

        </div>

        <div className='my-auto pr-[10rem] smallScreens:pr-16'>
          <img src={heroImg} alt="" className="h-[450px] w-[74.2rem] object-contain rounded-xl smallScreens:ml-8 smallScreens:mt-8 animate-fadeInUp" />
        </div>
      </div>


      <div className='flex items-center justify-center gap-12 mt-[5.8rem]' >
        <img src={line} alt="" className='h-1 w-7' />
        <p className='text-xl font-bold text-[#818891] uppercase tracking-widest'>About  SBAAA LLC</p>
        <img src={line} alt="" className='h-1 w-7' />
      </div>

      <div className='flex items-center justify-center mt-8' ref={topDivRef}>
        <h1 className='font-bold text-[4.4rem] smallScreens:text-[3rem] text-center w-2/5 smallScreens:w-full animate-fadeInUp'>Your Partner in Small Business Success</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-14 " ref={getStartedNowRef}>
        <div className='my-auto pl-[10rem] smallScreens:pl-[2rem] smallScreens:pr-[2rem]'>
          <img src={businesssuccess} alt="" className="h-auto rounded-xl smallScreens:h-[20rem] w-[100%]" />
        </div>

        <div className="my-auto pl-[8rem] pr-[20%] smallScreens:pl-[2rem] smallScreens:pr-[2rem]">
          <h5 className="text-[1.8rem] font-medium text-[#173363]">
            At SBAAA LLC, we understand the unique challenges you face as a small business owner
          </h5>
          <p className="mt-6 text-[#64666C] text-[1.6rem] font-normal">
            Balancing day-to-day operations while trying to grow your business can feel overwhelming. That’s why we’ve created a comprehensive suite of services, programs, and partnerships designed to empower you with the tools, knowledge, and connections you need to thrive.
          </p>

          <div className="mt-10">
            <label className="font-normal text-2xl focus:outline-none">Select State</label>
            <div className="relative mt-4 custom-scrollbar focus:outline-none">
              <Select
                options={states}
                styles={customStyles}
                onChange={handleChange}
                placeholder="States"
                classNamePrefix="custom-select"
              />
            </div>
            {errors.state && (
              <p className="text-red-500 text-[1.2rem] mt-1">
                {errors.state.message}
              </p>
            )}
          </div>

          {/* Checkbox and Links */}
          <div className="mt-10 flex items-start">
            <input
              type="checkbox"
              id="terms"
              className="my-2 mr-3 ml-2 custom-checkbox"
              checked={isAgreed}
              onChange={(e) => setIsAgreed(e.target.checked)}
            />
            <label htmlFor="terms" className="text-[1.4rem] text-[#64666C]">
              By clicking the Get Started Now button, you agree to the
              <Link
                to="/terms"
                target="_blank"

                className="font-medium text-[#173363] underline mx-2"
              >
                Terms & Conditions
              </Link>
              and
              <Link
                to="/privacy-policy"
                target="_blank"
                className="font-medium text-[#173363] underline ml-2"
              >
                Privacy Policy
              </Link>.
            </label>
          </div>

          {/* Button */}
          <Button
            label="Get Started Now"
            className={`blueBtn mt-12 h-[5rem] ${!isAgreed ? "opacity-50 cursor-not-allowed" : ""}`}
            onClick={handleButtonClick}
            disabled={!isAgreed}
          />
          <p className='mt-6 text-[#64666C] text-[1.6rem] font-normal'>No obligation, no credit card required</p>
        </div>


        {/* <div className="my-auto pl-[8rem] pr-[20%] smallScreens:pl-[2rem] smallScreens:pr-[2rem]">
          <h5 className="text-[1.8rem] font-medium text-[#173363]">At SBAAA LLC, we understand the unique challenges you face as a small business owner</h5>
          <p className="mt-6 text-[#64666C] text-[1.6rem] font-normal">
            Balancing day-to-day operations while trying to grow your business can feel overwhelming. That’s why we’ve created a comprehensive suite of services, programs, and partnerships designed to empower you with the tools, knowledge, and connections you need to thrive.
          </p>

          <div className="mt-10">
            <label className="font-normal text-2xl focus:outline-none">Select State</label>
            <div className="relative mt-4 custom-scrollbar focus:outline-none">
              <Select
                options={states}
                styles={customStyles}
                onChange={handleChange}
                placeholder="States"
                classNamePrefix="custom-select"
              />
            </div>
            {errors.state && (
              <p className="text-red-500 text-[1.2rem] mt-1">
                {errors.state.message}
              </p>
            )}
          </div>

          <Button label="Get Started Now" className="blueBtn mt-12 h-[5rem]" onClick={validationHandler} />
        </div> */}
      </div>

      <div className='flex items-center justify-center gap-12 mt-[10rem]'>
        <img src={line} alt="" className='h-1 w-7' />
        <p className='text-xl font-bold text-[#818891] uppercase tracking-widest'>Our Services</p>
        <img src={line} alt="" className='h-1 w-7' />
      </div>

      <div className='flex items-center justify-center mt-8 smallScreens:mx-8'>
        <h1 className='font-bold text-[4.4rem] smallScreens:text-[2.5rem] text-center w-3/5 smallScreens:w-full'>Customized Business Support to Drive Your Success and Growth</h1>
      </div>
      <p className="mt-4 text-center text-[#64666C] text-2xl font-normal smallScreens:mx-8">At SBAAA LLC, we offer a range of services designed to meet the diverse needs of small business owners.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 p-4 mt-14 max1440:px-[10%] px-[10%] smallScreens:px-[5%] mediumScreens:px-[5%]">


        <div className="rounded-2xl p-10 flex items-center mb-6 shadow-custom-light transition-transform duration-300 transform hover:scale-105 hover:shadow-custom-light2">
          <img src={hand} alt="" className='w-[5.5rem] h-[4.8rem] mr-10' />
          <div>
            <h2 className="text-[2rem] font-semibold">Business Advisory</h2>
            <p className="mt-4 text-[#64666C] text-[1.6rem] font-normal leading-normal">Tailored advisory services for your business toward growth.</p>
            <div className='flex items-center mt-4'>
              <p className="text-[#173363] text-2xl font-semibold mr-2 cursor-pointer" onClick={scrollToTop}>Book Now</p>
              <img src={dblArrow} alt="" className='w-[1.2rem] h-[1.2rem]' />
            </div>
          </div>
        </div>

        <div className="rounded-2xl p-10 flex items-center mb-6 shadow-custom-light transition-transform duration-300 transform hover:scale-105 hover:shadow-custom-light2">
          <img src={hand} alt="" className='w-[5.5rem] h-[4.8rem] mr-10' />
          <div>
            <h2 className="text-[2rem] font-semibold">Bookkeeping</h2>
            <p className="mt-4 text-[#64666C] text-[1.6rem] font-normal leading-normal">Comprehensive bookkeeping for new and emerging businesses.</p>
            <div className='flex items-center mt-4'>
              <p className="text-[#173363] text-2xl font-semibold mr-2 cursor-pointer" onClick={scrollToTop}>Book Now</p>
              <img src={dblArrow} alt="" className='w-[1.2rem] h-[1.2rem]' />
            </div>
          </div>
        </div>

        <div className="rounded-2xl p-10 flex items-center mb-6 shadow-custom-light transition-transform duration-300 transform hover:scale-105 hover:shadow-custom-light2">
          <img src={hand} alt="" className='w-[5.5rem] h-[4.8rem] mr-10' />
          <div>
            <h2 className="text-[2rem] font-semibold">Established Business</h2>
            <p className="mt-4 text-[#64666C] text-[1.6rem] font-normal leading-normal">Advanced bookkeeping services for established businesses.</p>
            <div className='flex items-center mt-4'>
              <p className="text-[#173363] text-2xl font-semibold mr-2 cursor-pointer" onClick={scrollToTop}>Book Now</p>
              <img src={dblArrow} alt="" className='w-[1.2rem] h-[1.2rem]' />
            </div>
          </div>
        </div>

      </div>

      <div className='text-center mb-10'>
        <Button label="See All" className="blueBtn mt-12" />
      </div>

      <div
        className="grid grid-cols-2 smallScreens:grid-cols-1 gap-4 p-4 h-[60rem] smallScreens:h-full bg-cover bg-no-repeat bg-center mt-[5rem] smallScreens:pb-12"
        style={{ backgroundImage: `url("${img6}")` }}
      >
        <div className="flex flex-col items-center justify-center pl-[20%] smallScreens:pl-[1%] smallScreens:mt-8">
          <div>
            <h1 className="font-bold text-[4.4rem] smallScreens:text-[2.4rem] text-white">Commitment to Your Success</h1>
            <p className="mt-4 text-white text-2xl font-normal leading-9">
              At SBAAA LLC, we are dedicated to delivering tailored business development services, working closely with you to understand your goals and create a roadmap for sustainable success. Our experienced team offers strategic planning, innovative solutions, and dedicated support to help you achieve your business dreams.
            </p>

            {/* <p className="mt-4 text-white text-2xl font-normal leading-9">
              At SBAAA LLC, we are committed to providing top-notch business development services tailored to your needs.
            </p> */}

            <Link to={PATHS.services}>
              <Button label="Discover More" className="blueBtn mt-12" />
            </Link>
          </div>
        </div>
        <div>
          <div className="flex flex-col justify-center pr-[20%] pl-[20%] smallScreens:pl-[1%] smallScreens:pr-[1%] h-full">
            <div className="bg-white p-12 rounded-3xl shadow-lg smallScreens:w-full smallScreens:h-full w-[90%] h-[85%] relative smallScreens:mt-16">
              <h2 className="text-4xl font-bold mb-10">Contact Us</h2>

              <form onSubmit={handleSubmit(onSubmit)} className="space-y-8">
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex flex-col">
                    <input
                      type="text"
                      placeholder="Name"
                      {...register("name", { validate: validateName })}
                      className="text-2xl fix_height_input font-normal h-[5rem] border-2 pl-6 border-[#F5F5F2] p-3 rounded-xl focus:outline-none"
                    />
                    {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name.message}</p>}
                  </div>
                  <div className="flex flex-col">
                    <input
                      type="email"
                      placeholder="Email"
                      {...register("email", { validate: validateEmail })}
                      className="h-[5rem] fix_height_input text-2xl font-normal border-2 pl-6 border-[#F5F5F2] p-3 rounded-xl focus:outline-none"
                    />
                    {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>}
                  </div>
                </div>

                <div>
                  <div className="relative">
                    <Select
                      // className='select-class '
                      value={options?.find((option) => option.value === businessName)}
                      onChange={(selectedOption) => setBusinessName(selectedOption.value)}
                      options={options}
                      styles={customStyles}
                      placeholder="Select an option"
                    />
                  </div>
                  {errors?.businessName && (
                    <p className="text-red-500 text-[1.2rem] mt-1">
                      {errors?.businessName.message}
                    </p>
                  )}
                </div>
                <div>
                  <textarea
                    rows="6"
                    placeholder="Your Message"
                    {...register("message", { validate: validateMessage })}
                    className="w-full text-2xl font-normal border-2 pl-6 pt-4 border-[#F5F5F2] p-3 rounded-xl focus:outline-none smallScreens:mb-16"
                  />
                  {errors.message && <p className="text-red-500 text-sm mt-1">{errors.message.message}</p>}
                </div>
                <div>
                  <button
                    type="submit"
                    className="blueBtn absolute bottom-[4rem] smallScreens:bottom-8"
                    disabled={loading}
                  >
                    {loading ? <Loader /> : "Submit Now"}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className='flex items-center justify-center gap-12 mt-[5.8rem]'>
        <img src={line} alt="" className='h-1 w-7' />
        <p className='text-xl font-bold text-[#818891] uppercase tracking-widest'>Knowledge Hub</p>
        <img src={line} alt="" className='h-1 w-7' />
      </div>

      <div className='flex items-center justify-center mt-8'>
        <h1 className='font-bold text-[4.4rem] smallScreens:text-[3rem] text-center w-3/5 smallScreens:w-full'>Trades Business Resources</h1>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 p-4 mt-14 px-[13%] max1440:px-[10%] smallScreens:px-[10%]">
        <div className="rounded-3xl mb-6 shadow-custom-light2 border border-[#E5E5E5] transition-transform duration-300 transform hover:scale-105 hover:shadow-custom-light2">
          <img src={homecard1} alt="" className='w-full h-[26rem] rounded-t-2xl' />
          <div className='p-6 mt-4 mb-2'>
            <span className='text-lg font-medium rounded-full bg-[#F5F5F2] p-4 py-2'>Marketing</span>
            <h2 className="text-[2rem] font-bold mt-5">Bookkeeping basics for trades people</h2>

          </div>
        </div>

        <div className="rounded-3xl mb-6 shadow-custom-light2 border border-[#E5E5E5] transition-transform duration-300 transform hover:scale-105 hover:shadow-custom-light2">
          <img src={img8} alt="" className='w-full h-[26rem] rounded-t-2xl' />
          <div className='p-6 mt-4 mb-2'>
            <span className='text-lg font-medium rounded-full bg-[#F5F5F2] p-4 py-2'>Development</span>
            <h2 className="text-[2rem] font-bold mt-5">Common mistakes small trades businesses make with finances</h2>

          </div>
        </div>

        <div className="rounded-3xl mb-6 shadow-custom-light2 border border-[#E5E5E5] transition-transform duration-300 transform hover:scale-105 hover:shadow-custom-light2">
          <img src={img9} alt="" className='w-full h-[26rem] rounded-t-2xl' />
          <div className='p-6 mt-4 mb-2'>
            <span className='text-lg font-medium rounded-full bg-[#F5F5F2] p-4 py-2'>Design</span>
            <h2 className="text-[2rem] font-bold mt-5">Compliance tips for electricians, plumbers, and HVAC professionals</h2>

          </div>
        </div>

      </div>

      <div className='bg-[#F2F2F282] py-[5rem] mt-[5.8rem]'>
        <div className='flex items-center justify-center gap-12'>
          <img src={line} alt="" className='h-1 w-7' />
          <p className='text-xl font-bold text-[#818891] uppercase tracking-widest'>FAQS</p>
          <img src={line} alt="" className='h-1 w-7' />
        </div>

        <div className='flex items-center justify-center mt-8'>
          <h1 className='font-bold text-[4.4rem] smallScreens:text-[3rem] text-center w-3/5 smallScreens:w-4/5'>Frequently Asked Questions</h1>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 mt-10 px-[15%] smallScreens:px-[5%] gap-8">
          <div>
            {collapseData?.map((item) => (
              <div
                key={item?.id}
                className="border-0 rounded-lg mb-8 shadow-custom-light2 bg-white px-10"
              >
                <button
                  className="flex items-center w-full p-4 transition duration-300 h-[8rem]"
                  onClick={() => toggleSection(item?.id)}
                >
                  <span
                    className={`text-3xl font-bold mr-10 transition-transform duration-300 ${openSection === item?.id ? " text-[#20BAD1]" : "text-gray-600"
                      }`}
                  >
                    {openSection === item?.id ?
                      <img src={minus} className='w-[15px] h-[3px] mr-2' />
                      :
                      <img src={plus} className='h-[15px] w-[15px] mr-2' />
                    }
                  </span>
                  <span className="font-bold text-[1.4rem] mt-1 text-left">{item?.title}</span>
                </button>

                <div
                  className={`overflow-hidden transition-max-h duration-500 ease-in-out ${openSection === item?.id ? "max-h-96" : "max-h-0"
                    }`}
                >
                  <div className="bg-white font-normal text-[1.4rem] text-[#363049] px-[6rem] smallScreens:px-[1rem] pb-[3rem] leading-relaxed">{item?.content}</div>
                </div>
              </div>
            ))}
          </div>

          <div>
            {collapseData2?.map((item) => (
              <div
                key={item?.id}
                className="border-0 rounded-lg mb-8 shadow-custom-light2 bg-white px-10"
              >
                <button
                  className="flex items-center w-full p-4 transition duration-300 h-[8rem]"
                  onClick={() => toggleSection(item?.id)}
                >
                  <span
                    className={`text-3xl font-bold mr-10 transition-transform duration-300 ${openSection === item?.id ? " text-[#20BAD1]" : "text-gray-600"
                      }`}
                  >
                    {openSection === item?.id ?
                      <img src={minus} className='w-[15px] h-[3px] mr-2' />
                      :
                      <img src={plus} className='h-[15px] w-[15px] mr-2' />
                    }
                  </span>
                  <span className="font-bold text-[1.4rem] mt-1 text-left">{item?.title}</span>
                </button>

                <div
                  className={`overflow-hidden transition-max-h duration-500 ease-in-out ${openSection === item?.id ? "max-h-96" : "max-h-0"
                    }`}
                >
                  <div className="bg-white font-normal text-[1.4rem] text-[#363049] smallScreens:px-[1rem] px-[6rem] pb-[3rem] leading-relaxed">{item?.content}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className='text-center'>
          <Link to={PATHS.faqs}>
            <Button label="Learn More" className="blueBtn mt-12" />
          </Link>
        </div>
      </div>


    </>
  )
};

export default Home;